import { Directive, HostListener, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Helper } from 'libraries/Helper';
import { FontCharacters } from 'domain-models/FontCharacters';
import { NgModel } from '@angular/forms';
import { Fonts } from 'domain-models/Fonts';
import { BadWords } from 'domain-models/BadWords';

@Directive({
	selector: '[ngModel][signInputValidator]'
})
export class SignInputValidatorDirective {
	//if you have only ONE prop you can use alias and named it the same and on html do
	//<input type="text" [appInputFormat]="'uppercase'"> instead of
	//<input type="text" appInputFormat [format]="'uppercase'">
	private enable: boolean;
	@Input('maxPixels') maxPixels;
	@Input('font') font: Fonts;
	@Output('change') change = new EventEmitter<number>();
	@Output() ngModelChange: EventEmitter<any> = new EventEmitter();

	@Input('enable')
	set Enable(val: boolean) {
		this.enable = val;
		this.onNgModelchange(null);
	}

	get Enable() {
		return this.enable;
	}

	constructor(private el: ElementRef, private model: NgModel) {}

	@HostListener('focus') onFocus() {
		//console.log("On focus");
		let value: string = this.el.nativeElement.value;

		if (!this.enable) {
			this.el.nativeElement.value = '';
			Helper.showNotification('top', 'right', 'Please select DMS location first', 4);
		}
	}
	@HostListener('input') onNgModelchange(event) {
		let value: string =
			this.el.nativeElement.value == '' ? this.model.model : this.el.nativeElement.value;
		//let value: string = this.model.model;
		if (!value) return;
		value = value.toLowerCase();
		var badWords: BadWords[] = JSON.parse(localStorage.getItem('badWords'));
		var temp = value.replace(/\s/g, ' ');
		temp = temp.replace(/_/g, ' ');
		temp = temp.replace(/-/g, ' ');
		//temp = temp.replace(/./g, '');
		//temp = temp.replace(/!/g, '');

		let words = temp.split(' ');

		if (temp != '') {
			words.forEach((word) => {
				if (badWords.find((bw) => bw.Name == word)) {
					this.el.nativeElement.value = '';
					this.ngModelChange.emit('');
					Helper.showNotification('top', 'right', 'You can <b>NOT</b> write that', 4); //show message
					return;
				}
			});
			if (temp.search('trump') != -1) {
				this.el.nativeElement.value = '';
				this.ngModelChange.emit('');
				Helper.showNotification('top', 'right', 'You can <b>NOT</b> write that', 4); //show message
				return;
			}
		}
		if (!this.enable) {
			this.el.nativeElement.value = '';
			this.ngModelChange.emit('');
		} else {
			return;
			/*
      //hard coded font id for debuggin
      //this.fontId = 1;
      //flag representing you exceded the number of characters availables
      var tooLong: boolean = false;
      //get the fontCharacters table from local storage (it was saved when opening DMS Control page)
      var fontCharacters: FontCharacters[] = JSON.parse(localStorage.getItem("fontCharacters-" + this.font.Id));
      //Reset the local counter to 0
      this.counter = 0;
      //Reset index to 0
      var index = 0;
      //Break the input string by characters

      value.split("").forEach(character => {
        //search the character in the FontCharacter object array, and return the fontcharacter object
        // so if you are looking for A, the return will be: {WidthInPixels:5, OtherProperty:ItsValue}
        if (character == " ") character = ""; //change space to "" because for some reason the API is not returning the blank space
        var fontCharacter: FontCharacters = fontCharacters.find(font => font.AsciiValue == character)
        if (fontCharacter) {
          this.counter += fontCharacter.WidthInPixels + this.font.CharSpacing; //Increase the local counter with the width of the character you got from the table
          if (this.counter > this.maxPixels) { //if counter exceeds 
            this.counter -= fontCharacter.WidthInPixels + this.font.CharSpacing; //delete the just added width
            tooLong = true; //enable the flag
            Helper.showNotification("top", "right", "You have reached the limit of characters", 4);//show message
            return;//break the foreach
          }
          index++;//increase the index
        }
        else { //if the character was not found show message, and behive like its to long so that it will delete it
          Helper.showNotification("top", "right", "That character is not available for this Font. Please choose a different font", 4);
          tooLong = true;
          return;
        }

      });
      if (tooLong) { //flag telling you there are more characters than allowed
        this.model.valueAccessor.writeValue("Error!");
        this.el.nativeElement.value = value.substring(0, index);//delete the extra characters
        this.ngModelChange.emit(this.el.nativeElement.value)
      }
      this.change.emit(this.counter);//notify the new value of counter :)
      */
		}
	}

	@HostListener('blur') onBlur() {
		if (!this.enable) {
			this.el.nativeElement.value = '';
		}
	}

	// @HostListener('window:keyup', ['$event'])
	// keyEvent(event: KeyboardEvent) {
	//   let value: string = this.el.nativeElement.value;
	//   value = value.toUpperCase();
	//   if (!this.enable) {
	//     this.el.nativeElement.value = "";
	//   }
	//   else {
	//     //hard coded font id for debuggin
	//     //this.fontId = 1;
	//     //flag representing you exceded the number of characters availables
	//     var tooLong: boolean = false;
	//     //get the fontCharacters table from local storage (it was saved when opening DMS Control page)
	//     var fontCharacters: FontCharacters[] = JSON.parse(localStorage.getItem("fontCharacters-" + this.fontId));
	//     //Reset the local counter to 0
	//     this.counter = 0;
	//     //Reset index to 0
	//     var index = 0;
	//     //Break the input string by characters

	//     value.split("").forEach(character => {
	//       //search the character in the FontCharacter object array, and return the fontcharacter object
	//       // so if you are looking for A, the return will be: {WidthInPixels:5, OtherProperty:ItsValue}
	//       if (character == " ") character = ""; //change space to "" because for some reason the API is not returning the blank space
	//       var fontCharacter: FontCharacters = fontCharacters.find(font => font.AsciiValue == character)
	//       if (fontCharacter) {
	//         this.counter += fontCharacter.WidthInPixels; //Increase the local counter with the width of the character you got from the table
	//         if (this.counter > this.maxPixels) { //if counter exceeds
	//           this.counter -= fontCharacter.WidthInPixels; //delete the just added width
	//           tooLong = true; //enable the flag
	//           Helper.showNotification("top", "right", "You have reached the limit of characters", 4);//show message
	//           return;//break the foreach
	//         }
	//         index++;//increase the index
	//       }
	//       else { //if the character was not found show message, and behive like its to long so that it will delete it
	//         Helper.showNotification("top", "right", "That character is not available for this Font. Please choose a different font", 4);
	//         tooLong=true;
	//         return;
	//       }

	//     });
	//     if (tooLong) { //flag telling you there are more characters than allowed
	//       this.el.nativeElement.value = value.substring(0, index);//delete the extra characters
	//     }
	//     this.change.emit(this.counter);//notify the new value of counter :)
	//   }

	// }
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/directives/sign-input-validator/sign-input-validator.directive.ts